import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { EXHIBITION_PATH } from '@/shared/config';
import { buttonVariants } from '@/shared/ui';

/**
 * 끝난 기획전 링크로 들어온 목록 — 숨김·삭제·공개 상품 0 은 모두 NOT_FOUND 로 온다.
 * 빈 목록으로 보이게 두지 않고 기획전 화면으로 되돌린다.
 */
export const StoreExhibitionEnded = (): ReactElement => (
  <section className="flex flex-col items-center gap-4 py-16 text-center">
    <p className="text-muted-foreground">종료된 기획전입니다.</p>
    <Link to={EXHIBITION_PATH} className={buttonVariants({ variant: 'outline' })}>
      기획전 보러 가기
    </Link>
  </section>
);
